import { render } from "./tableEditorTest.vue?vue&type=template&id=8df9777c&scoped=true"
import script from "./tableEditorTest.vue?vue&type=script&lang=js"
export * from "./tableEditorTest.vue?vue&type=script&lang=js"

import "./tableEditorTest.vue?vue&type=style&index=0&id=8df9777c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df9777c"]])

export default __exports__